import {AppBar, Toolbar, Typography} from "@mui/material";


export default function Masthead() {
    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                backgroundColor: "transparent",
                backdropFilter: "blur(5px)"
            }}
        >
            <Toolbar>
                <Typography variant="h5" fontWeight={"bold"} flexGrow={1}>
                    Personally
                </Typography>
                {/* This could be confusing */}
                {/*<Button variant={"outlined"} sx={{fontWeight: "bold"}} disabled={true} startIcon={<GlobeIcon/>}>*/}
                {/*    Coming soon*/}
                {/*</Button>*/}
            </Toolbar>
        </AppBar>
    )
}